import React, { useEffect, useMemo } from 'react'
import { BookingMonthlyStatusTable } from 'components/bookings'
import { Error } from 'components/common'
import { useBookingStatusOfTheMonthQuery } from 'lib/graphql/storeadmin'
import { Moment } from 'moment'
import { getListOfFullMonthDates } from 'lib/str-formatter'
import { PageProps } from 'gatsby'

type MonthlyTableType = {
  currentDate: Moment
  page: PageProps<Queries.Query>
  handleDailyView: (day: moment.Moment) => void
  onChangeToDaily: (data: boolean) => void
}

const MonthlyTable = ({
  currentDate,
  page,
  handleDailyView,
  onChangeToDaily,
}: MonthlyTableType) => {
  const listOfDates: string[] = useMemo(
    () => getListOfFullMonthDates(currentDate),
    [currentDate]
  )
  const { data, refetch, error, loading } = useBookingStatusOfTheMonthQuery({
    variables: { date: currentDate.format('YYYY-MM-DD') },
  })

  useEffect(() => {
    refetch({ date: currentDate.format('YYYY-MM-DD') })
  }, [currentDate, refetch, page.location])

  if (error) {
    return Error.render(error)
  }

  return (
    <>
      <BookingMonthlyStatusTable
        data={data}
        listOfDates={listOfDates}
        handleDailyView={handleDailyView}
        onChangeToDaily={onChangeToDaily}
        loading={loading}
      />
    </>
  )
}

export default MonthlyTable
